import { cn } from "../../../lib/utils";

export function HorizontalLineField({
  item,
  error,
  helperText,
  disabled,
  className,
  customClasses = {},
  ...props
}) {
  return (
    <div
      className={cn(
        "w-full h-px bg-gray-200 my-4",
        customClasses?.horizontalLine || "",
        className
      )}
      role="separator"
      aria-hidden="true"
      {...props}
    />
  );
}
